/* Forbo checkout guard — DRAFT rev 2026-10-07a
   FRONT-END GATE ONLY. See snippets/forbo-checkout-guard.liquid for exactly what
   this does and does not stop, and for the Shopify mechanism required to make it
   real. Do not treat a green run of this file as production enforcement.

   It reads the gate state from the Shopify cart itself (/cart.js), so the gate
   is correct after a refresh, in a second tab, and on any template — the state
   is not kept in this page's memory. It does not create a second cart and it
   never mutates the cart.
*/
(function () {
  'use strict';

  var node = document.getElementById('forbo-guard-config');
  if (!node) return;

  var cfg;
  try { cfg = JSON.parse(node.textContent); } catch (e) { return; }
  if (!cfg || !cfg.productId) return;

  var PRODUCT_ID = String(cfg.productId);
  var REQUIRED = cfg.requiredAttributes || [];

  var gated = false;       // Forbo samples in cart AND answers missing
  var banner = null;
  var styled = false;

  function ensureStyle() {
    if (styled) return;
    styled = true;
    var css = document.createElement('style');
    css.textContent = [
      // The cart drawer's footer is a two-column grid and the checkout <form> is
      // one of its cells, so spanning inside the form is not enough -- unnest()
      // below lifts the banner out of the row entirely. grid-column covers the
      // case where the banner itself IS the grid item. NOTE: no flex shorthand
      // here -- `flex:1 0 100%` inside the drawer's COLUMN flex container made
      // the banner grow to fill the whole drawer and hide the line items.
      '.forbo-guard-banner{margin:12px 0;padding:14px 16px;border-radius:6px;background:#fdf3e3;',
      'grid-column:1 / -1;flex:0 0 auto;width:100%;box-sizing:border-box;',
      'box-shadow:inset 0 0 0 1px #e9c88d;font-size:14px;line-height:1.45;color:#8a4b00;}',
      '.forbo-guard-banner strong{display:block;margin-bottom:8px;}',
      '.forbo-guard-banner a{display:inline-flex;align-items:center;min-height:44px;padding:10px 18px;',
      'border-radius:4px;background:#8a4b00;color:#fff;font-weight:700;text-decoration:none;}',
      '.forbo-guard-banner a:hover{background:#6a3800;color:#fff;}',
      '[data-forbo-guard-hidden]{display:none !important;}'
    ].join('');
    document.head.appendChild(css);
  }

  function placeBanner() {
    ensureStyle();
    if (banner && banner.isConnected) return banner;
    banner = document.createElement('div');
    banner.className = 'forbo-guard-banner';
    banner.setAttribute('role', 'alert');
    var strong = document.createElement('strong');
    strong.textContent = cfg.message;
    var a = document.createElement('a');
    a.href = cfg.samplePageUrl;
    a.textContent = cfg.ctaLabel;
    banner.appendChild(strong);
    banner.appendChild(a);

    // Put it next to whatever checkout control this template actually has.
    var anchor = document.querySelector(
      '[name="checkout"], .cart__checkout, #checkout, a[href$="/checkout"], a[href*="/checkout?"]'
    );
    var host = anchor ? (anchor.closest('form, .cart__footer, .cart-drawer__footer, .mini-cart__footer') || anchor.parentNode) : null;
    if (host) host.insertBefore(banner, host.firstChild);
    else document.body.appendChild(banner);
    unnest(banner);
    return banner;
  }

  // The cart drawer lays its footer out as `.mini-cart__buttons{display:grid;
  // grid-template-columns:212.5px 212.5px}` and the checkout <form> is the
  // SECOND cell -- so a banner inside that form is stuck in a 213px column next
  // to "View cart" no matter how many columns it is told to span. Walk up and
  // lift the banner out of any ancestor that is laying its children out in a
  // row, so it lands on a full-width line above the buttons instead.
  function unnest(b) {
    for (var i = 0; i < 4; i++) {
      var host = b.parentElement;
      if (!host || host === document.body) return;
      var outer = host.parentElement;
      if (!outer || !outer.parentNode) return;
      var cs = window.getComputedStyle(outer);
      var cols = (cs.gridTemplateColumns || 'none').trim();
      var rowish =
        (cs.display.indexOf('grid') !== -1 && cols !== 'none' && cols.split(/\s+/).length > 1) ||
        (cs.display.indexOf('flex') !== -1 && cs.flexDirection.indexOf('row') === 0 && outer.children.length > 1);
      if (!rowish) return;
      outer.parentNode.insertBefore(b, outer);
    }
  }

  function dropBanner() {
    if (banner && banner.parentNode) banner.parentNode.removeChild(banner);
    banner = null;
  }

  // Express / accelerated checkout cannot be intercepted reliably, so it is
  // hidden while the gate is on. Mitigation, not enforcement.
  var EXPRESS = [
    '.shopify-payment-button',
    '[data-shopify="dynamic-checkout-cart"]',
    '[data-shopify="payment-button"]',
    '.dynamic-checkout__content',
    '#dynamic-checkout-cart',
    '.cart__dynamic-checkout-buttons',
    '.additional-checkout-buttons'
  ].join(',');

  function toggleExpress(on) {
    Array.prototype.forEach.call(document.querySelectorAll(EXPRESS), function (el) {
      if (on) el.setAttribute('data-forbo-guard-hidden', '');
      else el.removeAttribute('data-forbo-guard-hidden');
    });
  }

  function evaluate(cart) {
    var items = (cart && cart.items) || [];
    var hasForbo = items.some(function (i) { return String(i.product_id) === PRODUCT_ID; });
    if (!hasForbo) return false;
    var attrs = (cart && cart.attributes) || {};
    // Checks the ACTUAL answers, not a questionnaire_complete boolean.
    return REQUIRED.some(function (k) {
      var v = attrs[k];
      return typeof v !== 'string' || !v.trim();
    });
  }

  // Hold an UNWRAPPED fetch for the guard's own reads. The wrapper installed
  // below used to re-schedule refresh() on every /cart URL, and refresh()
  // itself reads /cart.js through window.fetch — so it fed itself and polled
  // /cart.js forever (measured ~7 req/sec on an idle page). Never read the
  // cart through the wrapped fetch.
  var rawFetch = window.fetch ? window.fetch.bind(window) : null;

  // Many cart writes can land in a burst; coalesce them into one re-evaluation.
  var pending = null;
  function schedule() {
    if (pending) return;
    pending = setTimeout(function () { pending = null; refresh(); }, 120);
  }

  function refresh() {
    var f = rawFetch || fetch;
    return f('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        gated = evaluate(c);
        toggleExpress(gated);
        if (gated) placeBanner();
        else dropBanner();
        return gated;
      })
      .catch(function () { return gated; });
  }

  function isCheckoutTrigger(el) {
    if (!el || !el.closest) return false;
    return !!el.closest(
      '[name="checkout"], .cart__checkout, #checkout, ' +
      'a[href$="/checkout"], a[href*="/checkout?"], a[href*="/cart/checkout"], ' +
      'button[value="checkout"], input[name="checkout"]'
    );
  }

  function stop(e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    var b = placeBanner();
    if (b && b.scrollIntoView) b.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  // Capture phase so this runs before the theme's own cart handlers.
  document.addEventListener('click', function (e) {
    if (!gated) return;
    if (isCheckoutTrigger(e.target)) stop(e);
  }, true);

  document.addEventListener('submit', function (e) {
    if (!gated) return;
    var f = e.target;
    if (!f || !f.getAttribute) return;
    var action = (f.getAttribute('action') || '');
    var submitter = e.submitter;
    var isCheckoutSubmit =
      /\/checkout/.test(action) ||
      (submitter && (submitter.name === 'checkout' || submitter.value === 'checkout'));
    if (isCheckoutSubmit) stop(e);
  }, true);

  // Any cart mutation anywhere in the theme re-evaluates the gate, so the cart
  // drawer and mini-cart stay correct without this file knowing their markup.
  // Only a cart MUTATION should re-evaluate the gate. Reads must not, or the
  // guard's own /cart.js read re-triggers this and loops.
  var MUTATES = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  if (window.fetch) {
    var realFetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var result = realFetch.apply(this, arguments);
      if (MUTATES.test(url)) result.then(schedule, function () {});
      return result;
    };
  }

  // The theme writes the cart with jQuery XHR (cart_add_url: '/cart/add'), not
  // fetch, so wrapping fetch alone would miss the cart drawer and mini-cart.
  if (window.XMLHttpRequest && XMLHttpRequest.prototype.open) {
    var realOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      try { if (MUTATES.test(String(url || ''))) this.addEventListener('loadend', schedule); } catch (e) {}
      return realOpen.apply(this, arguments);
    };
  }

  document.addEventListener('cart:updated', refresh);
  document.addEventListener('cart:refresh', refresh);
  window.addEventListener('pageshow', refresh);        // back/forward cache
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) refresh();                   // another tab changed the cart
  });

  refresh();
})();
